<template>
  <div style="height: 100%">
    <div class="right-content" v-if="getMessage()!=''">
      <p v-html="getSidebarMessage()"></p>
    </div>
    <div>
      <div class="sidebarLabel ulBox">
        <div class="tabLeft" @click="toRight">
          <img src="../../../static/images/tabLeft.png" width="14" />
        </div>
        <div style="overflow: hidden">
          <ul class="tabBox" style="width: max-content" :style="{ position: 'relative', left: left + 'px' }">
            <li
              v-for="(tagItem, tagIndex) in chatDataCenter.sidebarLabel"
              :key="tagIndex"
              :class="tagLabel == tagIndex ? 'activeLabel' : 'defaultLabel'"
              @click="getQuestion(tagItem, tagIndex)"
            >
              {{ tagItem.tagName }}
            </li>
          </ul>
        </div>
        <div class="tabRight" @click="toLeft">
          <img src="../../../static/images/tabRight.png" width="14" />
        </div>
      </div>
      <div class="sidebarProblem">
        <ul>
          <li
            v-for="(
              questionItem, questionIndex
            ) in chatDataCenter.sidebarProblem"
            :key="questionIndex"
          >
            <span
              v-if="questionItem.contentType == 1"
              @click="sendContent(questionItem.content)"
            >
              <span>
                <img src="../../../static/images/question.png" width="16" style="vertical-align: super;" />
              </span>
              <span class="contentText" style="vertical-align: -3px">
                <span
                  style="
                    display: -webkit-box;
                    -webkit-line-clamp: 1;
                    -webkit-box-orient: vertical;
                    overflow: hidden;
                  "
                >
                  {{ questionItem.content }}
                </span>
              </span>
            </span>
            <span
              v-else-if="questionItem.contentType == 2"
              @click="skipLinks(questionItem.linkUrl)"
            >
              <span>
                <img src="../../../static/images/link.png" width="16" style="vertical-align: super;" />
              </span>
              <span class="contentText">
                <span
                  style="
                    display: -webkit-box;
                    -webkit-line-clamp: 1;
                    -webkit-box-orient: vertical;
                    overflow: hidden;
                  "
                >
                  {{ questionItem.content }}
                </span>
              </span>
            </span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
  import chatDataCenter from "../../jsSdk/chatDataCenter";
  export default {
    name: "right-show",
    data() {
      return {
        questionShow:true,
        chatDataCenter,
        currentLabel:0,
        tagLabel: 0,
        left: 0,
      }
    },
    mounted() {
      console.log(chatDataCenter.sidebarLabel)
    },
    methods:{
      /**
       * 根据companyId查询账户信息
       */
      sendContent:function (content) {
        chatDataCenter.sendMessageByContent(content)
      },
      questionContentClick:function () {
        this.questionShow = !this.questionShow;
      },
      /**
       * 侧边栏信息展示
       */
      getSidebarMessage:function () {
        if(chatDataCenter.linkInfo==null||
          chatDataCenter.linkInfo.sidebarMessage==undefined||
          chatDataCenter.linkInfo.sidebarMessage==null){
          return '';
        }
        var text = chatDataCenter.linkInfo.sidebarMessage
        return text;
      },
      getMessage(){
        var text = this.getSidebarMessage();
        text = text.replace(/<\/?p[^>]*>/gi,'');
        text = text.replace(new RegExp("&nbsp;", "g"), "");
        text = text.replace(/[|]*\n/, '') //去除行尾空格
        text = text.replace(/<br\s*\/?>/g,"");
        text = text.replace(/\s+/g,"");
        return text;
      },
      getList:function () {
        if(chatDataCenter.linkInfo==null||
          chatDataCenter.linkInfo.quesList==undefined||
          chatDataCenter.linkInfo.quesList==null){
          return [];
        }
        return chatDataCenter.linkInfo.quesList;
      },
      getQuestion:function (item,index) {
        this.tagLabel = index;
        chatDataCenter.getSidebarTagQuestionList(item.id);
      },
      /**
       * 跳转链接
       */
      skipLinks: function (link) {
        console.log(link);
        window.open(link);
      },

      toLeft() {
        const boxWidth = document.getElementsByClassName("tabBox")[1].clientWidth;
        console.log(this.left, boxWidth, this.left - -boxWidth / 2);
        if (this.left - -boxWidth / 2 > 35) {
          this.left -= 35;
        } else if (
          this.left - -boxWidth / 2 <= 35 &&
          this.left - -boxWidth / 2 > 16
        ) {
          this.left -= this.left - -boxWidth / 2 + 1;
        } else if (this.left - -boxWidth / 2 == 0) {
          this.left -= -10;
        }
      },
      toRight() {
        if (this.left < 0 && this.left > -16) {
          this.left = 0;
        } else if (this.left < 0) {
          this.left += 35;
        }
      },
    },
  }
</script>

<style scoped>
  @import "../../../static/css/main.css";
  .hotTagBox{
    display: flex;
    flex-wrap: wrap;
    max-height: 70px;
    overflow-y: auto;
    overflow-x: hidden;
  }
  .hotTag{
    padding: 5px;
    border: 1px solid;
    border-radius: 16px;
    font-size: 14px;
    margin: 2px 5px;
    color: #797a7a;
    cursor: pointer;
  }
  .hotTagBox::-webkit-scrollbar {
    display: none; /* Chrome Safari */
  }

  .hotTagBox {
    scrollbar-width: none; /* firefox */
    -ms-overflow-style: none; /* IE 10+ */
    overflow-x: hidden;
    overflow-y: auto;
  }
  .hotList{
    height: calc(100% - 125px);
    overflow-y: auto;
    overflow-x: hidden;
  }
  .hotList ul {
    padding: 10px;
  }
  .hotList ul li {
    font-size: 14px;
    margin: 10px 0;
    cursor: pointer;
    color: #797a7a;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .sidebarLabel,
  .sidebarProblem {
    font-size: 15px;
    line-height: 20px;
  }
  .sidebarLabel {
    padding: 0 16px;
  }
  .sidebarLabel ul {
    white-space: nowrap;
  }
  .sidebarLabel ul li {
    display: inline-block;
    padding: 8px 12px;
    cursor: pointer;
  }
  .activeLabel {
    color: #1296db;
    border-top: 2px solid #1296db;
  }
  .defaultLabel {
    border-top: 2px solid #fafafa;
  }

  .sidebarProblem ul {
    padding: 0 8px;
  }
  .sidebarProblem ul li {
    line-height: 32px;
    color: #1296db;
    cursor: pointer;
  }

  .ulBox {
    position: relative;
    overflow: hidden;
  }
  .tabBox {
    width: 100%;
    overflow: hidden;
  }
  .tabLeft {
    position: absolute;
    left: 0;
    top: 0;
    line-height: 42px;
  }
  .tabRight {
    position: absolute;
    right: 3px;
    top: 0;
    line-height: 42px;
  }
  .contentText {
    height: 32px;
    max-width: 230px;
    line-height: 32px;
    display: inline-block;
    vertical-align: bottom;
  }
</style>
